import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import SvgShowChart from '@material-ui/icons/TrendingUp';

import ViewStack from './ViewStack';
import ControlButton from './ControlButton';

const styles = (theme) => {
    return {
        button: {
            '&$selected': {
                backgroundColor: theme.palette.secondary.main,
            },
            '&$selected:hover:not($disabled)': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        default: {},
        selected: {},
        disabled: {}
    };
}

const Mode = Object.freeze({
    open: 0,
    close: 1,
    disabled: 2,
    hidden: 3,
});

class GraphControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: Mode.hidden,
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        const nextView = nextProps.viewStack.peek();

        if (!nextView.layer) {
            return false;
        }

        const nextUid = nextView.uid;
        const [nextLayerType, nextLayerIndex] = nextView.layerSelection;

        if (this._uid !== nextUid ||
            this._layerType !== nextLayerType ||
            this._layerIndex !== nextLayerIndex) {

            this._uid = nextUid;
            this._layerType = nextLayerType;
            this._layerIndex = nextLayerIndex;

            this._updateState();
        }

        return (this.state.mode !== nextState.mode);
    }

    render = () => {
        const view = this.props.viewStack.peek();

        if (this.state.mode === Mode.hidden) {
            return null;
        }

        this._uid = view.uid;

        const {classes} = this.props;

        const selected = (this.state.mode === Mode.open);
        const selectState = (selected) ? classes.selected : classes.default;

        const buttonClasses = {
            disabled: classes.disabled,
        }

        return (
            <div className={this.props.className}>
                <ControlButton
                    tooltip='Toggle graph'
                    tooltipPlacement='left'
                    className={classNames(classes.button, selectState)}
                    classes={buttonClasses}
                    onClick={this._handleClick}
                    disabled={(this.state.mode === Mode.disabled)}
                >
                    <SvgShowChart/>
                </ControlButton>
            </div>
        );
    }

    _updateState = () => {
        const view = this.props.viewStack.peek();

        if (this.props.viewStack.isDefaultBase()) {
            if (this.props.onClick) {
                this.props.onClick(false);
            }

            this.setState({
                mode: Mode.hidden,
            });

            return;
        }

        const selectedLayerData = view.selectedLayerData;

        const allow = (!this.props.viewStack.isDefaultBase() &&
            selectedLayerData && selectedLayerData.graph);

        if (!allow) {
            this.setState({
                mode: Mode.disabled,
            });

            if (this.props.onClick) {
                this.props.onClick(false);
            }
        } else if (this.state.mode === Mode.disabled) {
            this.setState({
                mode: Mode.close,
            });

            if (this.props.onClick) {
                this.props.onClick(false);
            }
        } else if (this.state.mode === Mode.hidden) {
            this.setState({
                mode: Mode.close,
            });

            if (this.props.onClick) {
                this.props.onClick(false);
            }
        }
    }

    _handleClick = (e) => {
        e.preventDefault();

        if (this.props.onClick) {
            this.props.onClick(!(this.state.mode === Mode.open));
        }

        this.setState({
            mode: this._flipState(),
        });
    }

    _flipState = () => {
        return (this.state.mode === Mode.open) ? Mode.close :
            ((this.state.mode === Mode.close) ? Mode.open : this.state.mode);
    }
}

GraphControl.propTypes = {
    viewStack: PropTypes.instanceOf(ViewStack).isRequired,
    onClick: PropTypes.func,
}

export default withStyles(styles)(GraphControl);
